import React from "react";
import { Link } from "react-router-dom";
import { Lock, Zap, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

const TR = {
  sk: { available: "Dostupné len v PRO", default: "Táto funkcia vyžaduje aktívne predplatné.", cta: "Aktivovať PRO" },
  en: { available: "Available only in PRO", default: "This feature requires an active subscription.", cta: "Activate PRO" },
  cs: { available: "Dostupné pouze v PRO", default: "Tato funkce vyžaduje aktivní předplatné.", cta: "Aktivovat PRO" },
  de: { available: "Nur in PRO verfügbar",  default: "Diese Funktion erfordert ein aktives Abonnement.", cta: "PRO aktivieren" },
  pl: { available: "Dostępne tylko w PRO",  default: "Ta funkcja wymaga aktywnej subskrypcji.", cta: "Aktywuj PRO" },
  fr: { available: "Disponible uniquement en PRO", default: "Cette fonctionnalité nécessite un abonnement actif.", cta: "Activer PRO" },
};

/**
 * Reusable "FREE limit reached / PRO required" inline notice.
 * Used by calculator pages and AI Advisor when the API returns 402 PRO_REQUIRED.
 */
export default function ProGate({ message, compact = false }) {
  const { lang } = useLang();
  const t = TR[lang] || TR.sk;
  return (
    <div
      data-testid="pro-gate"
      className={`border-l-2 border-gold-500 bg-gold-500/5 ${compact ? "p-3" : "p-5"} flex items-start gap-3`}
    >
      <Lock className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" strokeWidth={1.8} />
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <span className="wb-tag !text-gold-400 !border-gold-600">PRO</span>
          <span className="font-display font-bold text-sm">{t.available}</span>
        </div>
        <p className="text-xs text-zinc-300 leading-relaxed">
          {message || t.default}
        </p>
        <Link
          to="/pricing"
          data-testid="pro-gate-cta"
          className="wb-btn-primary inline-flex items-center gap-1.5 px-3 py-1.5 text-xs mt-3"
        >
          <Zap className="w-3 h-3" /> {t.cta} <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
